import React, { FunctionComponent, useState, useCallback } from 'react';
import { Link } from 'gatsby';
import { useCookies } from 'react-cookie';

import style from './CookieConsent.module.less';

export const CookieConsent: FunctionComponent = () => {
  const [{ euCookie }, setCookie] = useCookies(['euCookie']);
  const [visible, setVisible] = useState(!euCookie);

  const close = useCallback(() => {
    setVisible(false);
    setCookie('euCookie', true, {
      path: '/',
      maxAge: 60 * 60 * 24 * 365 // a year
    });
  }, []);

  if (!visible) {
    return <></>;
  }

  return (
    <div className={style.cookieConsent}>
      <div className={style.content}>
        <p>This site uses cookies. By continuing to browse the site you are agreeing to our use of cookies.</p>
        <p>You may disable cookies with your browser settings. <Link to="/privacy-policy">Find out more here →</Link></p>
        <button className={style.close} type="button" onClick={() => close()}>
          <svg width="35pt" height="35pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path d="m50 43.57l-28.926-28.926-6.4297 6.4297 28.926 28.926-28.926 28.926 6.4297 6.4297 28.926-28.926 28.926 28.926 6.4297-6.4297-28.926-28.926 28.926-28.926-6.4297-6.4297z" fill-rule="evenodd" />
          </svg>
        </button>
      </div>
    </div>
  );
};
